import { Component, Element, h } from '@stencil/core';

@Component({
  tag: 'kdx-category-selector',
  styleUrl: 'kdx-category-selector.scss',
  shadow: false,
})
export class KdxCategorySelector {
  @Element() root: HTMLElement;

  perSlideDesktop: number = 5;
  perSlideTablet: number = 3;
  perSlideMobile: number = 1;
  slides;
  componentDidLoad() {
    this.slides = this.root.querySelectorAll('.kdx-category, .kdx-category.glide__slide--clone');

    this.slides.forEach(slide => {
      slide.addEventListener('click', () => {
        if (this.root.querySelector('.active') !== null) {
          this.root.querySelector('.active').classList.remove('active');
        } else {
          slide.classList.add('active');
        }
      });
    });

  }

  render() {
    this.slides = this.root.querySelectorAll('.kdx-category, .kdx-category.glide__slide--clone');
  
    const totalSlides = this.slides.length;

    // Update perSlideDesktop, perSlideTablet, and perSlideMobile accordingly
    this.perSlideDesktop = Math.max(1, Math.min(totalSlides, 5));
    this.perSlideTablet = Math.max(1, Math.min(totalSlides, 3));
    this.perSlideMobile = Math.max(1, Math.min(totalSlides, 1));

    return (
      <div class="kdx-category-selector">
        <div class="kdx-category-selector__inner">
          <kdx-carousel 
            class="comp-load-defer"        
            bullet-nav="true" 
            display-bullet-nav-externally="true" 
            carousel-type="carousel"
            disable-arrows="false"
            peek={200}
            peek-tablet={100}
            peek-mobile={50}
            perSlide={this.perSlideDesktop.toString()} perSlideTablet={this.perSlideTablet.toString()} perSlideMobile={this.perSlideMobile.toString()}>

            <slot />
          </kdx-carousel>
        </div>
      </div>
    );
  }
}
